import React from 'react';
import { Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle, Backdrop, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export const Dialog = ({
    openDialog,
    widthDialog,
    styleDialog,
    title,
    styleTitle,
    content,
    styleContent,
    actions,
    styleActions,
    openLoadingOverlay,
    onClose
}) => {

    return (
        <>
            <MuiDialog
                sx={{ '& .MuiDialog-paper': styleDialog }}
                maxWidth={widthDialog}
                open={openDialog}
                onClose={onClose}
            >
                {
                    title &&
                    <DialogTitle
                        sx={{
                            ...styleTitle,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            pr: 1
                        }}
                    >
                        {title}
                        {onClose && (
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                sx={{ color: 'white' }}
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </DialogTitle>
                }
                <DialogContent sx={styleContent}>
                    {content}
                </DialogContent>
                <DialogActions sx={styleActions}>
                    {actions}
                </DialogActions>
                {openLoadingOverlay && (
                    <Backdrop
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: (theme) => theme.zIndex.modal + 1,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        open={true}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                )}
            </MuiDialog>
        </>
    )
}
